import { Button } from "@mui/material";
import styled from "styled-components";
import { COLORS } from "../../../../values/colors";

export const CustomButton = styled(Button)({
  border: `1px solid ${COLORS.darkGray} !important`,
  backgroundColor: `${COLORS.apronBrown} !important`, 
  color: "white !important", 
  borderRadius: "1.5rem !important",
  padding: ".5rem 3rem !important",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4) !important",
  textTransform: "none",
  "@media (max-width: 1050px)": {
    padding: ".5rem 2rem !important",
    textWrap: "nowrap",
  },
});

export const SubmitInput = styled.input.attrs({ type: 'submit' })({
  border: `1px solid ${COLORS.darkGray}`,
  backgroundColor: COLORS.apronBrown, 
  color: "white",
  borderRadius: "1.5rem",
  padding: ".5rem 3rem",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
  textTransform: "none",
  cursor: "pointer",
  fontSize: "1rem",
  "@media (max-width: 1050px)": {
    padding: ".5rem 2rem",
    whiteSpace: "nowrap",
  },
});
